import { useForm } from "@formspree/react";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import OnclickButton from "./OnclickButton";

function MultiStepForm({ colour, role }) {
	const [state, handleSubmit] = useForm("xoveaajo");
	const [activeStep, setActiveStep] = useState(1);
	const [formValues, setFormValues] = useState({
		name: "",
		email: "",
		phone: "",
		role: "",
		notes: "",
		cv: null, // For CV upload
	});
	const [formErrors, setFormErrors] = useState({});

	useEffect(() => {
		setFormValues((prevValues) => ({
			...prevValues,
			role: role || "",
		}));
	}, [role]);

	const validateStep = () => {
		let errors = {};
		if (activeStep === 1) {
			if (!formValues.name) errors.name = "Name is required";
			if (!formValues.email) errors.email = "Email is required";
			if (!formValues.phone) errors.phone = "Phone number is required";
		} else if (activeStep === 2) {
			if (!formValues.role) errors.role = "Role is required";
			if (!formValues.cv) errors.cv = "Please upload your CV";
		}
		setFormErrors(errors);
		return Object.keys(errors).length === 0;
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormValues({ ...formValues, [name]: value });
	};

	const handleFileChange = (e) => {
		setFormValues({ ...formValues, cv: e.target.files[0] });
	};

	const handleNextStep = () => {
		if (validateStep()) {
			setActiveStep(activeStep + 1);
		}
	};

	const handleFormSubmit = (event) => {
		event.preventDefault();
		if (!validateStep()) return;

		const formData = new FormData();
		formData.append("name", formValues.name);
		formData.append("email", formValues.email);
		formData.append("phone", formValues.phone);
		formData.append("role", formValues.role);
		formData.append("notes", formValues.notes);
		formData.append("cv", formValues.cv);

		handleSubmit(formData);
	};

	if (state.succeeded) {
		window.location.href = "/thank-you";
		return null;
	}

	// Inline styles for step indicator and error messages
	const styles = {
		stepIndicator: {
			marginBottom: "1rem",
		},
		steps: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
		step: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},
		circle: (isActive) => ({
			width: "30px",
			height: "30px",
			borderRadius: "50%",
			border: `1px solid ${colour}`,
			backgroundColor: isActive ? colour : "white",
			lineHeight: "30px",
			textAlign: "center",
			color: isActive ? "white" : "#00304B",
		}),
		line: (isActive) => ({
			flexGrow: 1,
			height: "1px",
			backgroundColor: colour,
			margin: "0 0px",
		}),
		label: {
			marginTop: "5px",
			color: "#fff",
		},
		errorText: {
			color: "red",
			fontSize: "0.875rem",
		},
	};

	const nameInputStyles = {
		border: "none",
		borderBottom: `1px solid #CEE4FF`,
		borderRadius: 0,
		padding: "10px",
		fontSize: "16px",
		color: "#333",
	};

	const emailInputStyles = {
		border: "none",
		borderBottom: "1px solid #CEE4FF",
		borderRadius: 0,
		padding: "10px",
		fontSize: "16px",
		color: "#333",
	};

	const textareaStyles = {
		border: "1px solid #CEE4FF",
		borderRadius: "0px",
		padding: "10px",
		fontSize: "16px",
		resize: "none",
	};

	return (
		<section id="multi-form" className="py-5 py-lg-7">
			<Container>
				<Row className="justify-content-center">
					<Col md={10} lg={7} xl={6}>
						<div style={styles.stepIndicator}>
							<div style={styles.steps}>
								{/* Step 1 */}
								<div style={styles.step}>
									<div style={styles.circle(activeStep >= 1)}>1</div>
								</div>
								{/* Line */}
								<div style={styles.line(activeStep > 1)}></div>
								{/* Step 2 */}
								<div style={styles.step}>
									<div style={styles.circle(activeStep >= 2)}>2</div>
								</div>
							</div>
						</div>
					</Col>
				</Row>
				<Row className="justify-content-center">
					<Col md={9} lg={6} xl={5}>
						<div className="text-center mt-4 mb-3">
							<h2 className="text-primary">Submit your details</h2>
							<p>
								Please provide your details to proceed with your application.
							</p>
						</div>
						<Form className="w-100" onSubmit={handleFormSubmit}>
							{/* Step Indicator */}

							{activeStep === 1 && (
								<>
									<Form.Group className="mb-4" controlId="name">
										<Form.Label className="">Enter your name:</Form.Label>
										<Form.Control
											style={nameInputStyles}
											className="  special-placeholder"
											name="name"
											placeholder="Full name"
											type="text"
											value={formValues.name}
											onChange={handleInputChange}
											required
										/>
										{formErrors.name && (
											<span style={styles.errorText}>{formErrors.name}</span>
										)}
									</Form.Group>

									<Form.Group className="mb-4" controlId="email">
										<Form.Label className="">Enter your email:</Form.Label>
										<Form.Control
											className=" special-placeholder  "
											name="email"
											type="email"
											style={emailInputStyles}
											placeholder="email@example.com"
											value={formValues.email}
											onChange={handleInputChange}
											required
										/>
										{formErrors.email && (
											<span style={styles.errorText}>{formErrors.email}</span>
										)}
									</Form.Group>

									<Form.Group className="mb-5" controlId="phone">
										<Form.Label className="">
											Enter your phone number:
										</Form.Label>
										<Form.Control
											className="  special-placeholder "
											name="phone"
											placeholder="Phone number"
											style={emailInputStyles}
											type="tel"
											value={formValues.phone}
											onChange={handleInputChange}
											required
										/>
										{formErrors.phone && (
											<span style={styles.errorText}>{formErrors.phone}</span>
										)}
									</Form.Group>

									<div className="text-center ">
										<OnclickButton
											width="w-100 w-md-auto"
											colour={colour}
											text="Next"
											isOutline={false}
											onClick={handleNextStep}
										/>
									</div>
								</>
							)}

							{activeStep === 2 && (
								<>
									<Form.Group className="mb-4" controlId="role">
										<Form.Label className="">
											Enter your preferred role:
										</Form.Label>
										<Form.Control
											style={nameInputStyles}
											className=" special-placeholder"
											name="role"
											type="text"
											placeholder="Role"
											value={formValues.role}
											onChange={handleInputChange}
											required
										/>
										{formErrors.role && (
											<span style={styles.errorText}>{formErrors.role}</span>
										)}
									</Form.Group>

									<Form.Group className="mb-4" controlId="cv">
										<Form.Label>CV Upload *</Form.Label>
										<Form.Control
											style={{ border: "1px solid #CEE4FF" }}
											className=" "
											name="cv"
											type="file"
											accept=".pdf,.doc,.docx"
											onChange={handleFileChange}
											required
										/>
										{formErrors.cv && (
											<span style={styles.errorText}>{formErrors.cv}</span>
										)}
									</Form.Group>

									<Form.Group className="mb-5" controlId="notes">
										<Form.Control
											className=" "
											style={textareaStyles}
											name="notes"
											as="textarea"
											rows={4}
											placeholder="Enter any additional notes..."
											value={formValues.notes}
											onChange={handleInputChange}
										/>
									</Form.Group>

									<div className="text-center ">
										<OnclickButton
											width="w-100 w-md-auto"
											colour={colour}
											text="Submit"
											isOutline={false}
											type="submit"
											disabled={state.submitting}
										/>
									</div>
								</>
							)}
						</Form>
					</Col>
				</Row>
			</Container>
		</section>
	);
}

export default MultiStepForm;
